"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reciprocal = exports.divide = exports.multiply = exports.fixedToInt = exports.fromFixed = exports.toFixed = exports.fixed1 = exports.digits = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.digits = new bignumber_js_1.default('24');
exports.fixed1 = new bignumber_js_1.default('1000000000000000000000000');
var toFixed = function (n) {
    return exports.fixed1.times(n).integerValue(bignumber_js_1.default.ROUND_FLOOR);
};
exports.toFixed = toFixed;
// Keeps the decimal portion
var fromFixed = function (f) {
    return f.div(exports.fixed1);
};
exports.fromFixed = fromFixed;
// Returns an integer
var fixedToInt = function (f) {
    return f.idiv(exports.fixed1);
};
exports.fixedToInt = fixedToInt;
var multiply = function (a, b) {
    return a.times(b).idiv(exports.fixed1);
};
exports.multiply = multiply;
var divide = function (a, b) {
    return a.times(exports.fixed1).idiv(b);
};
exports.divide = divide;
var reciprocal = function (f) {
    return (0, exports.divide)(exports.fixed1, f);
};
exports.reciprocal = reciprocal;
//# sourceMappingURL=fixidity.js.map